import { Link } from "react-router-dom";
import { MatrixNodes, SlotProgress, levelPrice } from "./MatrixNodes";
import { Panel } from "./ui";

export const MatrixOverview = ({ matrix }) => {
    const current = matrix.levels.find((l) => l.level === matrix.currentLevel);
    const upcoming = matrix.levels.slice(1, 7);
    return (
        <Panel
            title="Matrix Levels"
            className="mt-6"
            testId="matrix-overview"
            action={
                <Link to="/dashboard/matrix" data-testid="matrix-view-all" className="text-[11px] font-bold text-nx-mute transition-colors duration-200 hover:text-nx-lime">
                    View all
                </Link>
            }
        >
            <div className="grid gap-6 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-nx-mute">Current Level</p>
                    <div className="mt-2 flex items-baseline gap-3">
                        <span className="text-4xl font-extrabold tracking-tight text-nx-lime tabular" data-testid="matrix-current-level">
                            L{current.level}
                        </span>
                        <span className="text-lg font-extrabold text-nx-text tabular">{levelPrice(current)}</span>
                    </div>
                    <div className="mt-5">
                        <SlotProgress filled={current.slotsFilled} total={current.slotsTotal} />
                    </div>
                    <div className="mt-6 grid grid-cols-3 gap-2">
                        {upcoming.map((l) => (
                            <div key={l.level} className="rounded-lg border border-white/5 bg-nx-soft px-3 py-2.5" data-testid={`matrix-mini-l${l.level}`}>
                                <p className="text-[10px] font-extrabold text-nx-mute">L{l.level}</p>
                                <p className="mt-0.5 text-xs font-extrabold text-nx-sub tabular">{levelPrice(l)}</p>
                            </div>
                        ))}
                    </div>
                    <Link to="/dashboard/matrix" className="mt-3 inline-block text-[11px] font-bold text-nx-mute transition-colors duration-200 hover:text-nx-lime">
                        +6 more levels
                    </Link>
                </div>
                <div className="flex items-center justify-center rounded-lg border border-white/5 bg-nx-base/60 p-6 lg:col-span-7">
                    <MatrixNodes slotsFilled={current.slotsFilled} />
                </div>
            </div>
        </Panel>
    );
};
